import { Box, Modal } from "@mui/material";
import React from "react";
import BetSheet from "./BetSheet";
import BetDialog from "./BetDialog";
import { Bet } from "../../types/Bet";
import { Match } from "../../types/Match";
import { useFixtures } from "../../common/contexts/fixturesContext";

interface BetModalProps {
  bet?: Bet;
  match?: Match;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isDesktop?: boolean;
}

const BetModal: React.FC<BetModalProps> = ({
  isOpen,
  setIsOpen,
  bet,
  match,
  isDesktop,
}) => {
  const { matches } = useFixtures();
  const currentMatch = matches.filter((m) => m.id === bet?.matchId)[0];
  const displayMatch = currentMatch || match;

  // Desktop: elegant MUI Dialog.
  if (isDesktop) {
    return (
      <BetDialog
        open={isOpen}
        setIsOpen={setIsOpen}
        bet={bet}
        match={match}
        displayMatch={displayMatch}
      />
    );
  }

  // Mobile: bottom-sheet (Stadium Night design system).
  return (
    <Modal open={isOpen} sx={modalSx}>
      <Box sx={{ outline: "none", width: "100%" }}>
        <BetSheet
          bet={bet}
          match={match}
          displayMatch={displayMatch}
          setIsOpen={setIsOpen}
        />
      </Box>
    </Modal>
  );
};

export default BetModal;

const modalSx = {
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  backdropFilter: "blur(6px)",
};
